
<div class="table__container">
  <div style="width: fit-content;" [matTooltip]="backDisabled() ? 'Changes have to be saved or removed before navigating away':''">
  <button mat-raised-button color="primary" (click)="goBack()" [disabled]="backDisabled()">
    <mat-icon matPrefix>arrow_back</mat-icon>
    Back
  </button>
</div>
<div>
  <button *ngIf="currentTable === 'Library'" (click)="selectAll()" mat-raised-button color="primary" style="float: right; top: 5em; right: 1em;">
    Grant Access To All
  </button>

</div>

  <h3>{{permissions}}</h3>
  <p>{{permissionsDetail}} <strong>{{location}}</strong></p>

 
 
  <table mat-table  [@tableTransition]="currentTable" *ngIf="currentTable === 'Library'"  [dataSource]="libraryData" class="table__inner">
    <!-- Library table content goes here -->
    <ng-container matColumnDef="name">
      
      <th mat-header-cell *matHeaderCellDef>Library Name</th>
      <td mat-cell *matCellDef="let row; let element" (click)="changeTable('Territory',row.id)">{{row?.properties[4].value}}</td>
    </ng-container>

    <ng-container matColumnDef="checked">
      <th mat-header-cell *matHeaderCellDef>
        <!-- <mat-checkbox #chkBox (change)="selectAll()" [checked]="isAllSelected()"> 
          Selected
        </mat-checkbox> -->
        Selected
      </th>
      
      <td mat-cell *matCellDef="let row">
        <mat-checkbox [(ngModel)]="row.checked" (click)="onStateChanging(row)" (change)="onStateChanged(row)" ></mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['name', 'checked']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['name', 'checked']"></tr>
  </table>

  <table mat-table [@tableTransition]="currentTable" class="table__inner" *ngIf="currentTable === 'Territory'" [dataSource]="territoryData">
    <!-- Category table content goes here -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Territory Name</th>
      <td mat-cell *matCellDef="let row" (click)="changeTable('Category', row.id)">{{row?.properties[4].value}}</td>
    </ng-container>

    <ng-container matColumnDef="checked">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox #chkBox [disabled]="shouldDisable()" (change)="selectAll()" [checked]="isAllSelected()">
          Selected
        </mat-checkbox>

      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox [disabled]="shouldDisable()" [(ngModel)]="row.checked"  (click)="onStateChanging(row)" (change)="onStateChanged(row)"></mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['name', 'checked']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['name', 'checked']"></tr>
  </table>
 
  <table mat-table [@tableTransition]="currentTable" *ngIf="currentTable === 'Category'" [dataSource]="categoryData" class="table__inner">
    <!-- Territory table content goes here -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Category Name</th>
      <td mat-cell *matCellDef="let row">{{row?.properties[4]?.value}}</td>
    </ng-container>

    <ng-container matColumnDef="checked">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox #chkBox [disabled]="shouldDisable()" (change)="selectAll()"  [checked]="isAllSelected()" >
          Selected
        </mat-checkbox>

      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox  [disabled]="shouldDisable()" (click)="onStateChanging(row)" [(ngModel)]="row.checked" (change)="onStateChanged(row)"></mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['name', 'checked']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['name', 'checked']" [ngClass]="{'hidden-row': !row?.properties[4]?.value}"></tr>
  </table>
</div>
<mat-paginator class="table__pagination" [pageSizeOptions]="pageSizeOptions" (page)="onPageOptionsChange($event)"></mat-paginator>

<button  mat-raised-button color="primary" (click)="save()" [disabled]="canSave()">Save</button>

<div *ngIf="(loading$ | async) && !dontShow" class="spinner">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="loadingSave$ | async" class="custom-spinner">
  <mat-spinner></mat-spinner>
  <div>{{progressMessage}}</div>
</div>

   
